{
  "newAdminScope": {
    "searchCustomers": "Søk etter kundenavn eller ID",
    "noCustomerMatches": "Ingen kunder samsvarer med søket.",
    "allCustomers": "Alle kunder",
    "customerNotFound": "Fant ikke denne kunden. Gå tilbake til kundelisten eller oppdater.",
    "duplicateWarning": "Det finnes allerede en kunde med dette navnet. Kontroller den eksisterende registreringen før du oppretter en ny.",
    "confirmDuplicate": "Jeg har kontrollert den eksisterende kunden og vil bruke samme navn.",
    "customerProjects": "Kundens prosjekter",
    "noCustomerProjects": "Ingen prosjekter er tilordnet denne kunden.",
    "assignProject": "Tilordne eksisterende prosjekt",
    "ownershipNotice": "Kundetilhørighet er kun metadata. Eksisterende operativ tilgang endres ikke.",
    "searchUnassignedProjects": "Søk etter ikke-tilordnede prosjekter med navn eller ID",
    "existingProject": "Eksisterende prosjekt",
    "selectProject": "Velg et ikke-tilordnet prosjekt",
    "noUnassignedMatches": "Ingen ikke-tilordnede prosjekter samsvarer med søket.",
    "assignProjectHint": "Tilordne prosjektet til {{customer}}. Kun ikke-tilordnede prosjekter er tilgjengelige. Prosjekter kan ikke overføres fra en annen kunde her.",
    "userSearch": {
      "placeholder": "Søk etter e-post eller SAP-ID",
      "hint": "Skriv minst 2 tegn fra e-post, SAP-ID eller navn, og velg en bruker.",
      "noResults": "Ingen samsvarende brukere tilgjengelig for tildeling.",
      "refine": "Viser {{shown}} av {{total}} treff. Avgrens søket.",
      "required": "Velg en eksisterende DWO-bruker fra søkeresultatene."
    },
    "nameRequired": "Skriv inn et navn.",
    "nameTooLong": "Bruk maksimalt 200 tegn.",
    "newProject": "Nytt prosjekt",
    "editProject": "Rediger prosjekt",
    "newUser": "Ny bruker",
    "editUser": "Rediger bruker",
    "externalId": "Ekstern ID",
    "workspaces": "Administrasjonsområder",
    "customerAdmin": "Kundeadministrasjon",
    "projectAdmin": "Prosjektadministrasjon",
    "customers": "Kunder",
    "customer": "Kunde",
    "projectAdministrators": "Prosjektadministratorer",
    "customerAdministrators": "Kundeadministratorer",
    "fullSystemAccess": "Systemadministrator · Alle områder",
    "newCustomer": "Ny kunde",
    "rename": "Endre kundenavn",
    "assign": "Registrer tildeling",
    "remove": "Fjern tildeling",
    "save": "Lagre",
    "cancel": "Avbryt",
    "person": "Eksisterende DWO-bruker",
    "status": "Status",
    "recordedBy": "Registrert av",
    "actionsLabel": "Handlinger",
    "assignments": "Administratortildelinger",
    "dormant": "Inaktiv",
    "dormantNotice": "Tildelingene er inaktive. Registrering gir ikke innlogging eller operativ tilgang.",
    "noCustomers": "Ingen kunder registrert.",
    "noAssignments": "Ingen administratortildelinger registrert for dette området.",
    "activity": "Aktivitetslogg",
    "noActivity": "Ingen aktivitet fra ny administrasjon registrert for dette området.",
    "saved": "Endringen er lagret.",
    "saveFailed": "Endringen ble ikke bekreftet. Oppdater for å kontrollere gjeldende registrering før du prøver igjen.",
    "removeConfirmation": "Fjerne administratortildelingen for {{name}}? Eksisterende operativ tilgang er uendret.",
    "operations": {
      "linkProject": "Tilordne eksisterende prosjekt til kunde",
      "create": "Ny kunde",
      "rename": "Endre kundenavn",
      "assign": "Registrer administratortildeling",
      "remove": "Fjern administratortildeling"
    },
    "actions": {
      "ASSIGN_PROJECT_TO_CUSTOMER": "Prosjekt tilordnet kunde",
      "CREATE_CUSTOMER": "Kunde opprettet",
      "RENAME_CUSTOMER": "Kundenavn endret",
      "RECORD_CUSTOMER_ADMIN": "Kundeadministrator registrert",
      "REMOVE_CUSTOMER_ADMIN": "Kundeadministrator fjernet",
      "RECORD_PROJECT_ADMIN": "Prosjektadministrator registrert",
      "REMOVE_PROJECT_ADMIN": "Prosjektadministrator fjernet"
    }
  },
  "newAdmin": {
    "entry": "Ny administrasjon",
    "legacy": "Gammel administrasjon",
    "administration": "Administrasjon",
    "systemAdmin": "Systemadministrator",
    "overview": "Systemoversikt",
    "projects": "Prosjekter",
    "people": "Personer",
    "administrators": "Systemadministratorer",
    "navigation": "Administrasjonsmeny",
    "breadcrumb": "Brødsmulesti",
    "refresh": "Oppdater",
    "loading": "Laster administrasjonsdata",
    "offline": "Koble til serveren for å se administrasjonsdata.",
    "loadFailed": "Kunne ikke laste administrasjonsdata.",
    "retry": "Prøv igjen",
    "searchPeople": "Søk etter navn, brukernavn eller SAP-ID",
    "searchProjects": "Søk etter prosjektnavn, ID eller kilde",
    "results": "{{count}} treff",
    "name": "Navn",
    "username": "Brukernavn",
    "email": "E-post",
    "sapId": "SAP-ID",
    "projectId": "Prosjekt-ID",
    "source": "Kilde",
    "division": "Divisjon",
    "completionSystem": "Ferdigstillelsessystem",
    "projectGrants": "Operative prosjekttilganger",
    "noProjectGrants": "Ingen operative prosjekttilganger registrert.",
    "user": "Bruker",
    "notProvided": "Ikke oppgitt",
    "noPeople": "Ingen personer samsvarer med søket.",
    "noProjects": "Ingen prosjekter samsvarer med søket.",
    "pageRange": "{{start}}–{{end}} av {{total}}",
    "previous": "Forrige side",
    "next": "Neste side",
    "updatedAt": "Sist oppdatert:",
    "close": "Lukk"
  },
  "app": {
    "update": {
      "message": "En oppdatering er tilgjenglig",
      "confirm": "Installer"
    },
    "offlineWarning": {
      "message": "Internett-tilkobling mistet",
      "description": "Du vil bli tatt til <strong>Offline</strong> modus. Du vil fremdeles ha tilgang til dine <strong>nedlastede</strong> arbeidsordre"
    },
    "offlineToolbar": {
      "info": "Offline Modus",
      "connected": "Tilkoblet internett",
      "disconnected": "Ingen nettverk tilgjenglig",
      "switchToOnline": "Bytt til online modus",
      "offlineChanges": "Offline endringer",
      "rejectedChanges": "Ikke lagret. Avviste endringer beholdt på denne enheten: {{count}}.",
      "review": "Vis avviste endringer",
      "closeReview": "Lukk oversikten",
      "changeId": "Endrings-ID",
      "created": "Opprettet",
      "reason": "Årsak",
      "attachments": "Beholdte vedlegg",
      "handlerRejected": "Serveren avviste endringen. Den ble ikke lagret.",
      "invalidChange": "Endringen inneholder ugyldige data. Den ble ikke lagret.",
      "discard": "Forkast lokal endring",
      "discardTitle": "Forkaste denne avviste endringen?",
      "discardConfirmation": "Dette sletter den valgte lokale endringen og vedleggene permanent. Data på serveren endres ikke. Andre endringer beholdes.",
      "connectionRequired": "Koble til serveren for å forkaste en endring.",
      "downloadBlocksDiscard": "Fjern den nedlastede kopien av arbeidsordren før du forkaster avviste endringer.",
      "discarded": "Lokal endring forkastet. Den ble ikke lagret på serveren.",
      "discardFailed": "Endringen kunne ikke forkastes. Oppdater listen og kontroller tilkoblingen."
    },
    "storageWarning": {
      "message": "Du har lite tilgjenglig plass.<br />For å gjøre det mulig å laste ned flere arbeidsordre- fjern gamle eller ubrukte."
    }
  },
  "disclaimers": {
    "updateDownloaded": "Noen av dine nedlastede arbeidsordrer trenger å oppdateres"
  },
  "components": {
    "searchBar": {
      "ok": "Ok",
      "cancel": "Avbryt"
    },
    "emptyList": {
      "title": "Denne listen er tom",
      "info": "Ingen artikkler funnet"
    },
    "confirm": {
      "cancel": "Avbryt",
      "confirm": "Bekreft"
    },
    "cableDialog": {
      "article": "Artikkel",
      "articleMissing": "Artikkel er ikke satt på arbeidslinjen og dialogen for kabeltrekking kunne ikke brukes.",
      "company": "Firma",
      "notSelected": "Ikke valgt",
      "editCompany": "Rediger firma",
      "loadingLocations": "Laster lokasjoner…",
      "location": "Lokasjon",
      "quantity": "(ANT: {{quantity}})",
      "locationRequired": "Lokasjon er påkrevd",
      "plannedLength": "Planlagt lengde",
      "pulledFromDrum": "Trukket fra trommel",
      "wholeNegative": "Verdien kan ikke være negativ",
      "wholeNotNumber": "Heltallsverdien godtar kun tall",
      "wholeRequired": "Feltet kan ikke være tomt",
      "decimalNegative": "Desimalverdien kan ikke være negativ",
      "decimalMax": "Desimalverdien kan ikke overstige 99",
      "decimalNotNumber": "Desimalverdien godtar kun tall",
      "asPlanned": "Som planlagt",
      "cancel": "Avbryt",
      "confirm": "Bekreft"
    },
    "quantityDialog": {
      "allDone": "Alt ferdig",
      "cancel": "Avbryt",
      "confirm": "Bekreft",
      "done": "Ferdig",
      "total": "Total"
    },
    "putOnHoldInfoDialog": {
      "title": "Arbeidsordren er satt på vent",
      "description": "Satt på vent av ",
      "close": "Lukk"
    },
    "documentStatusDialog": {
      "title": "Sett dokumentstatus",
      "cancel": "Avbryt",
      "confirm": "Bekreft"
    },
    "imagePreview": {
      "viewLarger": "Vis større bilde",
      "close": "Lukk",
      "zoomIn": "Zoom inn",
      "zoomOut": "Zoom ut",
      "resetZoom": "Tilbakestill zoom"
    }
  },
  "header": {
    "workCenter": "Arbeidssenter",
    "project": "Prosjekt"
  },
  "profile": {
    "filterWorkCenters": "Finn arbeidssenter...",
    "filterProjects": "Finn prosjekt...",
    "selectCompanyStepTitle": "Velg firma per prosjekt",
    "selectCompanyStepDescription": "Firma kreves for å bruke lagerplasseringen som brukes av kabeltrekking. Du kan hoppe over dette hvis du ikke bruker denne funksjonen.",
    "loadingCompanies": "Laster firmaer...",
    "company": "Firma",
    "noCompaniesForProject": "Ingen firmaer tilgjengelig for dette prosjektet.",
    "roles": {
      "FOREMAN": "Formann",
      "OPERATOR": "Operatør"
    },
    "continue": "Fortsett",
    "done": "Ferdig",
    "back": "Tilbake",
    "removeFromSelection": "Fjern fra utvalg: ",
    "removeSiteConfirm": "Fjern denne lokasjonen fra utvalget ditt?",
    "removeWorkCenterConfirm": "Fjern dette arbeidssenteret fra utvalget ditt?",
    "removeProjectConfirm": "Fjern dette prosjektet fra utvalget ditt?",
    "workOrderDateInfo": "Kun arbeidsordrer med planlagt startdato innenfor de neste 180 dagene vil vises.",
    "workCenterReplacementInfo": "EPUE-koder vil bli erstattet med nye arbeidssenter (Q%). Vær oppmerksom på at prosjektet ditt fortsatt kan bruke EPUE inntil utskiftingen er fullført."
  },
  "workOrderComments": {
    "title": "Notater",
    "add": {
      "confirm": "Legg til",
      "cancel": "Avbryt"
    },
    "edit": {
      "editNote": "Rediger kommentar",
      "deleteNote": "Slett kommentar",
      "saveNote": "Lagre",
      "changePhoto": "Endre bilde",
      "changeVideo": "Endre video"
    },
    "delete": {
      "deleteNoteBy": "Slett notat av"
    },
    "replies": {
      "replyAction": "Svar",
      "reply": "svar",
      "replies": "svar",
      "show": "· Vis",
      "hide": "· Skjul",
      "placeholder": "Skriv et svar… (Enter for å sende, Shift+Enter for ny linje)",
      "send": "Send",
      "cancel": "Avbryt"
    },
    "referenceType": {
      "WORK_ORDER": "Arbeidsordre",
      "WORK_LINE": "Arbeidslinje",
      "MATERIAL": "Material",
      "EQUIPMENT": "Utstyr",
      "OBJECT": "Objekt",
      "DOCUMENT": "Dokument",
      "MIPS_CONSTRUCTION": "Construction-kommentar",
      "MIPS_ENGINEERING": "Engineering-kommentar",
      "MIPS_MATERIAL": "Material-kommentar"
    },
    "list": {
      "addNote": "Legg til notat",
      "workOrderNote": null
    },
    "empty": {
      "title": "Siden er tom",
      "info": "Du kan starte å legge til notater med “lag notat” knappen."
    }
  },
  "workOrderFeedback": {
    "title": "Jobbtilbakemelding",
    "summary": {
      "workOrder": "Arbeidsordre",
      "title": "Tittel",
      "platform": "Lokasjon",
      "taskNo": "Task No",
      "date": "Dato"
    },
    "prompt": {
      "title": "Hvordan gikk jobben?",
      "info": "Velg en status. Ved negativ eller nøytral tilbakemelding må du skrive en kort kommentar slik at jobbkortet kan forbedres."
    },
    "sentiment": {
      "NOT_GOOD": "Ikke bra",
      "NEUTRAL": "OK, men trenger forbedring",
      "GOOD": "Bra"
    },
    "topicsTitle": "Hva gjelder tilbakemeldingen?",
    "commentLabel": "Kommentar",
    "commentPlaceholder": "Beskriv kort hva som fungerte / ikke fungerte.",
    "impactLabel": "Potensiell påvirkning",
    "impact": {
      "NONE": "Ingen",
      "SCHEDULE_PROGRESS": "Fremdrift / plan",
      "COST": "Kostnad",
      "HMS": "HMS",
      "QUALITY": "Kvalitet",
      "UNSURE": "Usikker"
    },
    "performedByLabel": "Utført av",
    "improvementLabel": "Foreslått forbedring",
    "improvementPlaceholder": "Hva bør endres før neste gjennomføring?",
    "submit": "Send tilbakemelding",
    "submitting": "Sender...",
    "submitSuccess": "Tilbakemelding sendt.",
    "submitQueuedOffline": "Tilbakemeldingen er lagret offline og synkroniseres når forbindelsen er tilbake.",
    "submitError": "Kunne ikke sende tilbakemelding. Prøv igjen.",
    "recipientWarning": "Ingen mottaker-epost for tilbakemelding er konfigurert for dette prosjektet.",
    "noRecipientConfirm": {
      "title": "Ingen mottaker-epost konfigurert",
      "description": "Dette prosjektet mangler mottaker-epost for tilbakemelding. Tilbakemeldingen kan lagres, men ingen e-post blir sendt.",
      "saveAnyway": "Lagre likevel"
    },
    "resend": "Send på nytt",
    "resending": "Sender på nytt...",
    "resendSuccess": "Tilbakemelding sendt på nytt.",
    "resendError": "Kunne ikke sende tilbakemelding på nytt. Prøv igjen.",
    "previousTitle": "Dine tidligere tilbakemeldinger",
    "empty": {
      "title": "Ingen tilbakemeldinger ennå",
      "info": "Innsendte tilbakemeldinger vises her."
    },
    "validation": {
      "sentimentRequired": "Velg en status.",
      "commentRequired": "Kommentar er påkrevd for valgt status.",
      "potentialImpactRequired": "Velg minst én potensiell påvirkning."
    }
  },
  "workOrderDetails": {
    "assignTo": "Tildel",
    "claim": null,
    "description": "Beskrivelse",
    "equipment": {
      "customerId": null,
      "description": "Beskrivelse",
      "equipment": "Utstyr",
      "functionalLocation": null,
      "materialNo": "Materiale no.",
      "serialNo": null,
      "storageLocation": null
    },
    "hoursTable": {
      "header": {
        "description": "Beskrivelse",
        "hours": "Timer"
      },
      "row": {
        "estimate_hours": "Estimerte timer",
        "hours_remaining": "Gjenstående timer",
        "hours_earned_this_week": "Tjente timer denne uken"
      }
    },
    "estimatedHours": "Est. Timer",
    "finish": "Slutt",
    "madeBy": "Opprettet av",
    "releaseToAll": "Tilgjengelig for alle",
    "remainingHours": "Tid igjen",
    "start": "Start",
    "usedHours": "Tid brukt",
    "wbs": "WBS",
    "statusName": "Status",
    "precedingWorkOrder": "Foregående arbeidsordre",
    "succeedingWorkOrder": "Etterfølgende arbeidsordre",
    "relatedWorkOrders": "Relaterte arbeidsordre",
    "putOnHold": "Sett arbeidsordren på vent",
    "releaseWorkOrder": "Igangsett arbeidsordren",
    "confirmPutOnHoldTitle": "Sett Arbeidsordre:",
    "confirmPutOnHoldDescription": "{{ workOrderNumber }} på vent?",
    "confirmReleaseOnHoldDescription": "{{ workOrderNumber }}?",
    "operators": {
      "empty": {
        "info": "Ingen operatører funnet"
      }
    }
  },
  "workOrderDocuments": {
    "jobPackage": "Job",
    "attachment": "Att",
    "video": "Video",
    "timeDrawing": "Doc",
    "timeDrawings": "Time Drawings",
    "revision": "Revisjon",
    "unauthorized": "Du har ikke tilgang til dette dokumentet",
    "loadFailed": "Dokumentet kunne ikke lastes",
    "notAvailableOffline": "Dokumentet er ikke lastet ned for bruk uten nett",
    "empty": {
      "title": "Siden er tom",
      "info": "Ingen dokumenter finnes i denne arbeidsordren enda."
    },
    "notSupported": "Hvis nettleseren ikke kan vise dokumentet, klikk her for å laste det ned.",
    "status": {
      "redlineMarkup": "Redline Markup",
      "forInfo": "Til info",
      "noChange": "Ingen endring",
      "label": "Status: {{id}} ({{name}})",
      "notSetLabel": "Status: ikke satt"
    }
  },
  "offlineDownload": {
    "title": "Last ned for bruk uten nett",
    "options": {
      "files": "Filer:",
      "allFiles": "Alle filer",
      "jobPackage": "Jobbpakke",
      "attachments": "Vedlegg",
      "docs": "Dokumenter",
      "model3d": "3D-filer",
      "videos": "Videoer"
    },
    "badges": {
      "model3d": "3D",
      "video": "Video"
    },
    "metadata": "Metadata",
    "total": "Valgt: {{count}} dokumenter, {{size}}",
    "unknownSize": "(+ {{count}} med ukjent størrelse)",
    "progress": {
      "running": "{{done}}/{{total}} lastet ned, nedlastingen vil fortsette i bakgrunnen om du lukker dialogen.",
      "done": "Nedlasting ferdig, du kan lukke dialogen.",
      "doneWithFailures": "Nedlasting ferdig, men {{failed}} av {{total}} dokumenter feilet. Du kan lukke dialogen.",
      "failed": "Nedlastingen feilet. Sjekk tilkoblingen og prøv igjen."
    },
    "noDocuments": "Arbeidsordren har ingen dokumenter.",
    "loadFailed": "Dokumentlisten kunne ikke lastes.",
    "offline": "Du er frakoblet. Koble til nettet for å laste ned.",
    "status": {
      "queued": "Venter",
      "downloading": "Laster ned",
      "done": "Lastet ned",
      "failed": "Feilet"
    },
    "close": "Lukk",
    "download": "Last ned"
  },
  "workOrderLines": {
    "backTo": "Tilbake til",
    "confirmWarning": "Denne arbeidslinjen har bare {{quantity}} av {{plannedQuantity}} registrert",
    "confirmComplete": "Er du sikker på at du vil fullføre og lukke arbeidslinjen?",
    "confirmReOpenWarning": "Er du sikker på at du vil gjenåpne arbeidslinjen:",
    "confirmReOpenQuantityRevert": "Installert mengde vil bli tilbakestilt til {{quantity}} {{unit}}.",
    "cableCompanyIdMissing": "Firma-ID er ikke satt for dette prosjektet. Sett firma-ID i innstillinger for å laste lagerlokasjoner.",
    "cableArticleMissing": "Artikkel mangler for dette omfanget. Rapportering må gjøres i MIPS.",
    "cableNoLocationsFound": "Ingen lokasjoner funnet for det valgte firmaet. Kontroller at du har valgt riktig firma, eller kontakt din supervisor hvis du mistenker at lagerlokasjonene i MIPS ikke er oppdatert.",
    "cablePulledLengthExceedsAvailable": "Uttrukket lengde er lengre enn tilgjengelig på valgt lokasjon/trommel, vennligst velg en annen lokasjon/trommel.",
    "continueTo": "Fortsett til",
    "end": "Slutt",
    "installedQuantity": "Installert Qty.",
    "lineComplete": "Fullfør",
    "lineReopen": "Gjenåpne arbeidslinjen",
    "lineDescription": "Beskrivelse",
    "lineId": "ID",
    "lineNo": "Linje",
    "plannedQuantity": "Planlagt Qty.",
    "start": "Start",
    "work": "Tid",
    "empty": {
      "info": "Denne arbeidsordren inneholder ingen arbeidslinjer"
    }
  },
  "workOrderList": {
    "filters": {
      "open": "Alle",
      "closed": "Arkiv",
      "released": "Tilgjengelige",
      "unreleased": "Utilgjengelige",
      "assigned": "Mine",
      "downloaded": "Nedlastet",
      "dueThisWeek": "Frist denne uken",
      "overDue": "Forsinket"
    },
    "estimatedHours": "Est. Timer",
    "finish": "Slutt",
    "searchLabel": "Søk",
    "show": "Vis",
    "sortActHoursAsc": "Brukte timer (lav til høy)",
    "sortActHoursDesc": "Brukte timer (høy til lav)",
    "sortEstFinishDateAsc": "Slutt Dato (første til siste)",
    "sortEstFinishDateDesc": "Slutt Dato (siste til første)",
    "sortEstHoursAsc": "Estimerte timer (lav til høy)",
    "sortEstHoursDesc": "Estimerte timer (høy til lav)",
    "sortEstStartDateAsc": "Start Dato (første til siste)",
    "sortEstStartDateDesc": "Start Dato (siste til første)",
    "sortWorkOrderNumberAsc": "Alfabetisk (A to Å)",
    "sortWorkOrderNumberDesc": "Alfabetisk (Å to A)",
    "sortLabel": "Sorter",
    "start": "Start",
    "empty": {
      "info": "Ingen arbeidsordre funnet"
    }
  },
  "workOrderMaterials": {
    "material": "Materialer",
    "articleNumber": "Artikkel nr.",
    "available": "Ja",
    "description": "Beskrivelse",
    "quantity": "Antall",
    "status": "Tilgjengelig",
    "materialStatus": "Materialstatus",
    "unavailable": "Nei",
    "empty": {
      "info": "Denne arbeidsordren inneholder ingen materialer"
    },
    "location": "Sted",
    "filters": {
      "all": "Alle",
      "clear": "Fjern",
      "clearAll": "Fjern filtre",
      "noResultsTitle": "Ingen materialer samsvarer med filtrene",
      "noResultsInfo": "Prøv å justere eller fjerne filtrene over."
    }
  },
  "siteQuery": {
    "title": "Site Query",
    "loading": "Laster Site Queries…",
    "numberNotAssigned": "Ikke tildelt – lokalt utkast",
    "revision": "Rev.",
    "notProvided": "Ikke oppgitt",
    "yes": "Ja",
    "no": "Nei",
    "selectReason": "Velg årsak",
    "cancel": "Avbryt",
    "saving": "Lagrer…",
    "createSuccess": "Site Query-utkastet er lagret på arbeidsordren.",
    "createError": "Kunne ikke lagre Site Query. Prøv igjen.",
    "attachmentUploadError": "Site Query ble lagret, men ett eller flere vedlegg kunne ikke lastes opp.",
    "attachmentDownloadError": "Kunne ikke laste ned vedlegget.",
    "removeAttachment": "Fjern",
    "noAttachments": "Ingen vedlegg valgt.",
    "referencesLoading": "Laster tagger og dokumenter for arbeidsordren…",
    "referencesLoadError": "Kunne ikke laste referanser for arbeidsordren. Prøv igjen senere.",
    "noReferencesAvailable": "Ingen tagg- eller dokumentnumre tilgjengelig på arbeidsordren.",
    "referenceType": {
      "TAG": "Tagg",
      "DOCUMENT": "Dokument"
    },
    "attachmentsCount": "{{count}} vedlegg",
    "status": {
      "DRAFT": "Utkast",
      "CREATED": "Opprettet",
      "IN_PROGRESS": "Under behandling",
      "ANSWERED": "Besvart"
    },
    "reason": {
      "CLARIFY": "Klarifisering",
      "QUANTITY": "Kun mengdeendring"
    },
    "caseType": {
      "TOLERANCE_DEVIATION": "Avvik utenfor toleransegrenser",
      "OFFSHORE_CHANGE": "Endring foreslått offshore",
      "MATERIAL_REPAIR": "Reparasjon / skadet materiell",
      "OTHER_CLARIFICATION": "Annen klarifisering"
    },
    "sections": {
      "jobReference": "1. Referanse til jobb",
      "classification": "2. Klassifisering",
      "description": "3. Beskrivelse og foreslått løsning",
      "submitter": "4. Innsender"
    },
    "fields": {
      "documentType": "Dokumenttype",
      "number": "SQ-nummer",
      "revision": "Revisjon",
      "workOrderNumber": "Arbeidsordrenummer",
      "taskId": "Task ID",
      "title": "Dokumenttittel",
      "deliveryId": "Delivery ID",
      "site": "Lokasjon / site",
      "discipline": "Ansvarlig disiplin for svar",
      "reason": "Årsak til SQ",
      "caseType": "Sakstype",
      "quantityChange": "Mengdeendring",
      "scheduleImpact": "Påvirker fremdrift?",
      "materialNeed": "Behov for materiell?",
      "description": "Beskrivelse av problemet",
      "suggestedSolution": "Foreslått løsning",
      "references": "Referanser",
      "attachments": "Bilder / vedlegg",
      "initiatedBy": "Initiert av",
      "company": "Firma / arbeidslag",
      "date": "Dato og klokkeslett",
      "siteLeader": "Plassleder",
      "integrationManager": "Integrasjonsleder"
    },
    "list": {
      "ariaLabel": "Eksisterende Site Queries",
      "create": "Ny Site Query",
      "createFirst": "Ny Site Query",
      "emptyTitle": "Ingen eksisterende Site Queries for arbeidsordren",
      "loadErrorTitle": "Kunne ikke laste Site Queries",
      "loadError": "Prøv igjen. Arbeidsordren er ikke endret."
    },
    "create": {
      "backToList": "Tilbake til Site Queries",
      "heading": "Opprett Site Query-utkast",
      "description": "Referansen til arbeidsordren hentes fra denne arbeidsordren og kan ikke endres her.",
      "taskIdManualHint": "Arbeidsordrenummeret starter ikke med fire sifre. Skriv inn Task ID.",
      "taskIdError": "Task ID må bestå av nøyaktig fire sifre.",
      "workCenterMissing": "Arbeidsordren mangler arbeidssenter. Site Query kan ikke lagres uten dette.",
      "save": "Lagre utkast"
    }
  },
  "weightReport": {
    "title": "Vektendring / tilleggsarbeid",
    "sending": "Sender…",
    "cancel": "Avbryt",
    "duplicate": "Dupliser",
    "sendSuccess": "Vektskjema sendt",
    "sendError": "Kunne ikke sende vektskjemaet. Prøv igjen.",
    "lineSaveError": "Kunne ikke lagre linjen. Prøv igjen.",
    "lineDeleteError": "Kunne ikke slette linjen. Prøv igjen.",
    "send": {
      "action": "Send {{count}} linje(r)",
      "offlineHint": "Du må være tilkoblet for å sende skjemaet.",
      "pendingHint": "Venter på at offline-endringer synkroniseres før skjemaet kan sendes."
    },
    "status": {
      "draft": "Ikke sendt",
      "sent": "Sendt"
    },
    "currentSchema": {
      "title": "Gjeldende skjema",
      "empty": "Ingen linjer lagt til ennå"
    },
    "line": {
      "add": "Legg til linje",
      "addTitle": "Ny linje",
      "editTitle": "Rediger linje",
      "edit": "Rediger",
      "delete": "Slett",
      "save": "Lagre linje",
      "saving": "Lagrer…",
      "tag": "Tag / beskrivelse",
      "quantity": "Stk / meter",
      "descriptionColumn": "Materiell / arbeidsoperasjon",
      "status": "Status"
    },
    "jobCard": {
      "title": "Jobbkortinformasjon",
      "workOrderNumber": "Arbeidsordrenummer",
      "jobTitle": "Tittel",
      "platform": "Plattform",
      "performedBy": "Utført av / navn"
    },
    "registration": {
      "mainCategory": "Hovedkategori",
      "hours": "Timer brukt",
      "predefinedOptions": "Forhåndsdefinerte valg – velg alt som passer"
    },
    "category": {
      "ADDITIONAL_WORK": "Tilleggsarbeid",
      "WEIGHT_CHANGE": "Vektendring",
      "OTHER": "Annet"
    },
    "weight": {
      "installed": "Montert vekt",
      "removed": "Demontert vekt",
      "total": "Total vekt",
      "followUp": "Krever endringen oppfølging?",
      "followUpYes": "Ja",
      "followUpNo": "Nei",
      "description": "Beskrivelse av materiale / arbeid",
      "descriptionPlaceholder": "Beskriv kort hva som ble gjort, hvorfor det var tilleggsarbeid, og eventuell påvirkning på timer, vekt eller fremdrift."
    },
    "documentation": {
      "recipient": "Delt postkasse / mottaker",
      "recipientHint": "Konfigurert per prosjekt",
      "comment": "Kommentar til leder / integrasjonsansvarlig",
      "commentPlaceholder": "Eventuell tilleggskommentar eller behov for avklaring.",
      "attachments": "Vedlegg",
      "downloadAttachment": "Last ned",
      "attachmentsLoading": "Laster vedlegg...",
      "attachmentsPendingHint": "Disse filene lastes opp når linjen lagres.",
      "attachmentsOfflineHint": "Vedlegg krever internettforbindelse.",
      "noAttachments": "Ingen vedlegg",
      "attachmentLoadError": "Kunne ikke laste vedlegg.",
      "attachmentUploadError": "Kunne ikke laste opp ett eller flere vedlegg.",
      "attachmentDownloadError": "Kunne ikke laste ned vedlegget."
    },
    "details": {
      "sentAt": "E-post sendt",
      "notSent": "Ikke sendt"
    },
    "history": {
      "title": "Sendte skjemaer for denne arbeidsordren",
      "empty": "Ingen skjemaer sendt ennå",
      "lineCount": "{{count}} linje(r)"
    }
  },
  "workOrderObjectHierarchy": {
    "filters": {
      "search": "Søk objekt eller arbeidslinje",
      "type": "Type",
      "allTypes": "Alle typer",
      "percentage": "Prosent",
      "quantity": "Mengde",
      "cable": "Kabel",
      "allStatuses": "Alle statuser",
      "notStarted": "Ikke startet",
      "inProgress": "Pågår",
      "completed": "Fullført",
      "workType": "Arbeidstype",
      "allWorkTypes": "Alle arbeidstyper",
      "clear": "Tøm",
      "clearAll": "Fjern filtre",
      "noResultsTitle": "Ingen arbeidslinjer samsvarer",
      "noResultsInfo": "Prøv å endre eller fjerne filtrene."
    },
    "workLines": "Arbeidslinjer",
    "empty": {
      "info": "Denne arbeidsordren inneholder ingen arbeidslinjer"
    },
    "selectStatus": "Status"
  },
  "workOrderOperations": {
    "backTo": null,
    "continueTo": null,
    "end": null,
    "installedQuantity": null,
    "lineComplete": null,
    "lineDescription": null,
    "lineId": null,
    "lineNo": null,
    "plannedQuantity": null,
    "start": null,
    "workCenter": null,
    "empty": {
      "info": "Denne arbeidsordren inneholder ingen arbeidslinjer"
    }
  },
  "workOrderTimer": {
    "confirm": {
      "cancel": null,
      "confirm": null,
      "discard": null,
      "info": null,
      "reportOn": null,
      "selectOperation": null
    },
    "estimatedHours": null
  },
  "workOrderObject": {
    "selectAll": "Velg alle",
    "objectNumber": "Objekt nr.",
    "description": "Beskrivelse",
    "progressType": "Type",
    "progress": "Fremdrift",
    "completionSystem": "Ferdigstillingssystem",
    "select": "Velge",
    "apply": "Utfør",
    "checklistLink": "Digital Sjekkliste"
  },
  "workOrderObjectList": {
    "from": "Fra",
    "to": "Til",
    "cableRouteHeader": "Kabel ruter",
    "documents": "Dokumenter",
    "currentObject": "Nåværende",
    "fromObject": "Fra",
    "toObject": "Til",
    "empty": {
      "info": "Denne arbeidsordren inneholder ingen arbeidslinjer"
    }
  },
  "pushNotification": {
    "WO_ADD_COMMENT": {
      "WORK_ORDER": {
        "body": {
          "user": "User: ",
          "madeANote": ", just made a note on your current work order: "
        }
      },
      "DEFAULT": {
        "body": {
          "user": "User: ",
          "madeANote": ", just made a note on {{ referenceType }}: ",
          "onWorkOrder": ". On your current work order: "
        }
      }
    },
    "WO_PUT_ON_HOLD": {
      "header": "Work order put on hold",
      "body": {
        "prefix": "Work order: ",
        "suffix": ", has been put on hold by: "
      }
    },
    "WO_RELEASE_PUT_ON_HOLD": {
      "body": {
        "prefix": "User: ",
        "suffix": ", just reactivated the work order: "
      }
    },
    "WO_UPDATE_OBJ_PROGRESS": {
      "header": "Object progress was updated",
      "body": {
        "prefix": "User: ",
        "suffix": ", has updated progress on the work lines. On your current work order: "
      }
    },
    "WO_UPDATE_INSTALLED_QUANTITY_ON_WORK_LINE": {
      "header": "Object installed quantity was updated",
      "body": {
        "user": "User: ",
        "updated_quantity": ", has updated installed quantity on the work line: ",
        "on_work_order": ". On your current work order: "
      }
    },
    "WO_MARK_WORK_LINE_AS_COMPLETE": {
      "body": {
        "user": "User: ",
        "just_completed": ", just completed the work line: ",
        "on_work_order": ". On your current work order: "
      }
    },
    "WO_MARK_WORK_LINE_AS_OPEN": {
      "body": {
        "user": "User: ",
        "just_completed": ", has started the work line: ",
        "on_work_order": ". On your current work order: "
      }
    },
    "WO_DOCUMENT_PROCESSED": {
      "header": "Updated Documentation",
      "body": {
        "document": "Document no: ",
        "on_work_order": ", on work order: "
      }
    },
    "DEFAULT": {
      "header": "Action was taken",
      "body": "User: {{triggeredByName}} has made a change in {{referenceName}}:{{referenceType}} in {{sourceId}} with an event: {{eventType}}"
    }
  },
  "error": {
    "page": {
      "400": {
        "title": "Invalid web address",
        "description": "Did you type this address directly? Check for typos. Did you copy and paste the address? Check that you included the entire address.",
        "button": "Return to home base"
      },
      "403": {
        "title": "Key missing...",
        "description": "Looks like you don't have the necessary permissions to view this page.",
        "button": "Get on board"
      },
      "404": {
        "title": "Looks like the page is lost at sea",
        "description": "The page you're trying to find has disappeared or no longer exists.",
        "button": "Return to home base"
      },
      "500": {
        "title": "An unexpected error occurred",
        "description": "It's not you, it's us. We have been notified of the incident. Please try again later",
        "button": "Return to home base"
      }
    },
    "dialog": {
      "internal_server_error": {
        "title": "Intern server feil.",
        "description": "Prøv igjen senere, eller kontakt support.",
        "button": "OK"
      },
      "general_error": {
        "title": "Noe gikk galt.",
        "description": "Hvis problemet oppstår ijen, prøv å laste siden på ny eller kontakt support",
        "button": "OK"
      },
      "no_connection": {
        "title": "Kunne ikke laste innhold!",
        "description": "Ingen forbindelse til serveren.",
        "button": "Prøv på nytt"
      }
    }
  },
  "versionCheck": {
    "newVersionAvailable": "Ny versjon {{version}} er tilgjengelig!",
    "viewReleaseNotes": "Se utgivelsesnotater"
  }
}
